"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  name: "Alejandro Kalisch",
  role: "Director Ejecutivo",
  experience: "30 años liderando la industria",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_alejandro_kalisch.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_alejandro_kalisch.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_alejandro_kalisch.png-wvc-sizes"
}, {
  name: "Beatriz Mendoza",
  role: "Directora de Operaciones",
  experience: "Especialista en logística industrial",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_beatriz_mendoza.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_beatriz_mendoza.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_beatriz_mendoza.png-wvc-sizes"
}, {
  name: "Carlos Ruiz",
  role: "Director de Sostenibilidad",
  experience: "Experto en economía circular",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_carlos_ruiz.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_carlos_ruiz.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_carlos_ruiz.png-wvc-sizes"
}, {
  name: "Diana Herrera",
  role: "Directora Comercial",
  experience: "Estratega de mercados globales",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_diana_herrera.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_diana_herrera.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/liderazgo_diana_herrera.png-wvc-sizes"
}];
export default function TeamLeadership() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="258642" id="team-leadership" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`flex flex-col items-center text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="text-accent font-bold tracking-wider uppercase text-sm mb-3">
            NUESTRO LIDERAZGO
          </span>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Compromiso y Visión Estratégica
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-base md:text-lg font-default">
            Contamos con un equipo directivo de amplia trayectoria, dedicado a 
            impulsar la innovación y la excelencia en el sector del acero y el reciclaje.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {teamMembers.map((member, i) => <div key={i} data-index={i} className={`flex flex-col rounded-lg overflow-hidden border border-border shadow-md bg-card transition-all duration-700 ease-out delay-${i * 100} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <div className="relative h-64 sm:h-72 w-full overflow-hidden">
                <img src={member.image} data-wvc-srcset={member.imageSrcset} data-wvc-sizes={member.imageSizes} alt={`Retrato de ${member.name}, ${member.role}`} className="object-cover w-full h-full transition-transform duration-500 hover:scale-105" loading="lazy" />
              </div>
              <div className="bg-card p-6 flex flex-col flex-grow">
                <h3 className="font-default font-bold text-xl text-foreground mb-1">
                  {member.name}
                </h3>
                <p className="text-primary font-semibold text-sm mb-3">
                  {member.role}
                </p>
                <p className="text-muted-foreground text-sm mt-auto font-default">
                  {member.experience}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}